import { render, staticRenderFns } from "./CommunityEdit.vue?vue&type=template&id=a78c0246&scoped=true"
import script from "./CommunityEdit.vue?vue&type=script&lang=js"
export * from "./CommunityEdit.vue?vue&type=script&lang=js"
import style0 from "./CommunityEdit.vue?vue&type=style&index=0&id=a78c0246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78c0246",
  null
  
)

export default component.exports